import { combineReducers } from '@reduxjs/toolkit'

import customer from './customerSlice'
import monthly from './monthlySlice'
import comment from './commentSlice'

const reducer = combineReducers({
    customer,
    monthly,
    comment,
})

export default reducer
